"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteWarning = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
// eslint-disable-next-line import/prefer-default-export
exports.QuoteWarning = styled_components_1.default.div `
  background: #f09e0e1a;
  color: #f19e0f;
  padding: 16px;
  font-weight: 600;
  font-size: 10px;
  line-height: 12px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;

  & > :first-child {
    padding-right: 16px;
  }
`;
//# sourceMappingURL=styled.js.map